import { DocPage, Section, SpecTable } from "../../components/DocChrome";

export function AccessibilityPage() {
    return (
        <DocPage title="Accessibility" description="WCAG 2.2 AA target for the Workspace.">
            <Section title="Standards">
                <SpecTable
                    rows={[
                        ["Keyboard", "All interactive elements reachable; Escape closes overlays"],
                        ["Focus", "Visible focus-visible rings using primary"],
                        ["Semantics", "Native elements first; ARIA when needed"],
                        ["Forms", "Labels required; errors linked via aria-describedby"],
                        ["Contrast", "Brand blue/gold on approved surfaces only"],
                        ["Touch", "Minimum 44px control height (md size)"],
                        ["Motion", "Respect prefers-reduced-motion (token durations → 0)"],
                        ["Status", "Do not convey status by color alone — include text/dot"],
                    ]}
                />
            </Section>
        </DocPage>
    );
}
